<template>
    <div class="w-9 flex items-center justify-center"><checkbox></checkbox></div>
    <div class="w-20 pl-2 flex items-center cursor-pointer" @click="emit('user')"><Avatar :first-name="firstName" :last-name="lastName" :url="avatar" width="40" height="40" /></div>
    <div class="ds-table-row-text flex-1 max-w-screen-sm flex items-center cursor-pointer" @click="emit('user')">{{ name }}</div>
    <div class="ds-table-row-text flex-1 max-w-md flex items-center">{{ position }}</div>
    <div class="ds-table-row-text w-64 flex items-center">{{ department }}</div>
    <div class="ds-table-row-text w-24 flex items-center" v-if="archive">{{ fired }}</div>
    <div class="ds-table-row-text w-16 flex items-center justify-center" v-else>
        <RatingStars :rating="rating" size="sm" />
    </div>
</template>

<script setup lang="ts">
interface Props {
    employee: Employee,
    archive: boolean
}
import { computed } from 'vue'
import Avatar from '../Avatar.vue'
import RatingStars from '@/ui/RatingStars.vue'
import { Employee } from '@/types'
import dayjs from 'dayjs'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'
const emit = defineEmits(['user'])
const departmentStore = useDepartmentStore()
const scheduleStore = useScheduleStore()
const { employee } = defineProps<Props>()

const employment = computed(() => employee.employments[0])

const firstName = computed(() => employee.first_name)
const lastName = computed(() => employee.last_name)
const middleName = computed(() => employee.middle_name)
const avatar = computed(() => employee.avatar)
const name = computed(() => {
    const ln:string = (lastName.value) ? lastName.value : ''
    const fn:string = (firstName.value) ? firstName.value : ''
    const mn:string = (middleName.value) ? middleName.value : ''
    return `${ln} ${fn} ${mn}`
})
const department = computed(() => departmentStore.departments.find(dep => dep.id === employment.value.department)?.name )
const position = computed(() => scheduleStore.positions.find(pos => pos.id === employment.value.position)?.name )
const rating = computed(() => employment.value.rating)
const fired = computed(() => dayjs(employee.last_fired_at).format('YYYY-MM-DD'))
</script>

